import React from "react";
import Modal from "react-bootstrap/Modal";
import { FaTimes } from "react-icons/fa";
import OrdersView from "../OrdersView";
import { elakayAutoText } from "../../pageInside/dataElakay";


// Thin, new wrapper around the SAME order-detail component already used on /c/orders --
// OrdersView.js is not modified, not duplicated: it already only needs infoSource + getOrderID
// (its own fetch/loading/Stripe-payment-method calls are entirely self-contained, and it imports
// its own OrdersView.css already). The heavier Modal *shell* on /c/orders (OrdersModals in
// pageInside/exeemple_page/ComponentRegistry.jsx) is coupled to Orders.js's dynamic
// section-registry state, which /purchased has no reason to pull in -- this local Modal replaces
// only that shell, around the identical content component. Its own chrome uses ph-* classes
// (PurchaseHistory.css) rather than borrowing Orders.css's .orders-item-modal-close, whose live
// import status elsewhere in the app is unconfirmed.
const OrderDetailsModal = ({ show, onClose, infoSource, getOrderID }) => (
  <Modal show={show} onHide={onClose} size="xl" centered dialogClassName="ph-order-modal">
    <button type="button" className="ph-order-modal-close" onClick={onClose} aria-label={elakayAutoText("h_bbfa773e5a63a5", "Close")}>
      <FaTimes />
    </button>
    <div className="ph-order-modal-body">
      {getOrderID && <OrdersView infoSource={infoSource} getOrderID={getOrderID} />}
    </div>
  </Modal>
);

export default OrderDetailsModal;
